export default "__VITE_ASSET__DHOM5mhv__"